import React from 'react';
import { Box, Pagination, Select, MenuItem, Typography } from '@mui/material';

const PaginationControls = ({
  totalPages, currentPage, perPage, totalItems,
  onPageChange, onPerPageChange,
  perPageOptions = [12, 24, 42, 74, 102, 132],
}) => {
  const s = (currentPage - 1) * perPage + 1;
  const e = Math.min(currentPage * perPage, totalItems);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, mt: 4, mb: 2, width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', justifyContent: 'center', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '10px 20px' }}>
        
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => onPageChange(page)}   // ✅ solo el número
          size="small"
          sx={{
            '& .MuiPaginationItem-root': {
              fontFamily: 'var(--font-mono)', fontSize: '0.8rem', fontWeight: 600,
              borderRadius: 'var(--radius-sm)', border: '1px solid var(--border)',
              '&.Mui-selected': { backgroundColor: 'var(--accent)', color: '#fff', borderColor: 'var(--accent)' },
            },
          }}
        />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Select
            value={perPage}
            onChange={(e) => onPerPageChange(e.target.value)}   // ✅ solo el valor
            size="small"
            sx={{ minWidth: 70, fontFamily: 'var(--font-mono)', fontSize: '0.8rem', borderRadius: 'var(--radius-sm)' }}
          >
            {perPageOptions.map(o => (
              <MenuItem key={o} value={o} sx={{ fontFamily: 'var(--font-mono)', fontSize: '0.8rem' }}>{o}</MenuItem>
            ))}
          </Select>
          <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: '0.78rem', color: 'var(--text-muted)' }}>
            por pág.
          </Typography>
        </Box>
      </Box>

      <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: '0.78rem', color: 'var(--text-muted)' }}>
        Mostrando {s}–{e} de {totalItems} productos
      </Typography>
    </Box>
  );
};

export default PaginationControls;